'use client';

import { c as _c } from "react/compiler-runtime";
import { INTERACTIVE_SURFACE } from '@common/components/interaction';
import { SvgChevrondown } from '@common/icon';
import { cn } from '@core/utils';
interface TrendKeywordToggleProps {
  isOpen: boolean;
  onToggle: () => void;
}
export const TrendKeywordToggle = t0 => {
  const $ = _c(10);
  const {
    isOpen,
    onToggle
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = cn("flex size-36 shrink-0 items-center justify-center rounded-xsmall", INTERACTIVE_SURFACE);
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const t2 = isOpen ? "\uC6F0\uB85C \uD0A4\uC6CC\uB4DC \uC811\uAE30" : "\uC6F0\uB85C \uD0A4\uC6CC\uB4DC \uD3BC\uCE58\uAE30";
  const t3 = isOpen && "rotate-180";
  let t4;
  if ($[1] !== t3) {
    t4 = cn("size-16 transition-transform duration-200 motion-reduce:transition-none", t3);
    $[1] = t3;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  if ($[3] !== t4) {
    t5 = <SvgChevrondown className={t4} />;
    $[3] = t4;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== isOpen || $[6] !== onToggle || $[7] !== t2 || $[8] !== t5) {
    t6 = <button className={t1} aria-expanded={isOpen} aria-label={t2} onClick={onToggle}>{t5}</button>;
    $[5] = isOpen;
    $[6] = onToggle;
    $[7] = t2;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  return t6;
};